var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 7L14 8.08334V20H12V7Z","fill":"currentColor"}}),_c('rect',{attrs:{"x":"5","y":"5.07383","width":"2.25081","height":"14.2452","transform":"rotate(-67.1271 5 5.07383)","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }